import { CommonModule } from '@angular/common';
import { Component, effect, ElementRef, input } from '@angular/core';

import { IconSizes, IconUsageTypes, IrisIconComponent } from '@sondermind/iris/icon';
import { IrisTokenParserService } from '@sondermind/iris/shared';

@Component({
  selector: 'pill',
  imports: [CommonModule, IrisIconComponent],
  templateUrl: './pill.component.html',
  styleUrls: ['./pill.component.scss'],
  host: {
    'attr.data-test': 'pill',
    '[class.pill--has-background-token]': 'backgroundColorToken() !== ""',
    '[class.pill--has-text-color-token]': 'textColorToken() !== ""',
  },
})
export class PillComponent {
  readonly icon = input<string>('verified_user');
  readonly displayText = input<string>('');
  /** When true, the pill renders label text only (no icon). */
  readonly hideIcon = input<boolean>(false);
  /** Iris SCSS token (e.g. `$color-dec-turquoise-05`).
   * When empty, default pill background from styles applies. */
  readonly backgroundColorToken = input<string>('');
  /** Iris SCSS token passed to `iris-icon` `colorToken` (e.g. `$color-dec-kelly-100`). */
  readonly iconColorToken = input<string>('$color-dec-kelly-100');
  /** Iris SCSS token for pill label text (e.g. `$color-brand-1-base`).
   * When empty, default pill text color from styles applies. */
  readonly textColorToken = input<string>('');

  readonly backgroundColorFromToken = effect(() => {
    this.irisTokenParserService.setColorFromToken(
      this.backgroundColorToken(),
      'pill-background',
      this.element,
    );
  });

  readonly textColorFromToken = effect(() => {
    this.irisTokenParserService.setColorFromToken(
      this.textColorToken(),
      'pill-text',
      this.element,
    );
  });

  iconDecorativeUsage = IconUsageTypes.DECORATIVE;
  iconSmallSize = IconSizes.SM;

  constructor(
    private irisTokenParserService: IrisTokenParserService,
    private element: ElementRef<HTMLElement>,
  ) {}
}
